<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { tooltip } from '@svelte-plugins/tooltips';

    import MonitActionForSelectedJob from './MonitActionForSelectedJob.svelte';
    import TemplateHeaderTrio from '../../shared/TemplateHeaderTrio.svelte';
    import { api, connections_filter_config } from '../../../stores/api';
    import { app } from '../../../stores/app';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import SearchInput from '../../shared/SearchInput.svelte';
    import { routes, mainMenu } from '../../../stores/store';
    import { SettingsApi } from '../Settings/SettingsApi';
    import { filter } from '../../../stores/filter';
    import ConnectionList from './ConnectionList.svelte';
    import MenuContextJobs from '../MenuDropdown/MenuContextJobs.svelte';
    import IconHelp from '../../shared/Icons/IconHelp.svelte';
    import Opacity from '../../shared/Opacity.svelte';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import NoticeColor from '../../shared/NoticeColor.svelte';
    import WarningColor from '../../shared/WarningColor.svelte';
    import InlineInfoAboutAccountDisabilities from '../../shared/InlineInfoAboutAccountDisabilities.svelte';
    import { canWrite, writeDisabledBanner } from '../../shared/Permissions/writeAccess';
    import IconRoute from '../../shared/Icons/IconRoute.svelte';
    import IconTransaction from '../../shared/Icons/IconTransaction.svelte';

    let showMonit: boolean = false;
    let routeCounterWrapper: any = null;
    let routeCounterTooltip: {content: string, theme: string} = {content: '', theme: ''};
    let transactionCounterWrapper: any = null;
    let transactionCounterTooltip: {content: string, theme: string} = {content: '', theme: ''};

    onMount(() => {
        $mainMenu.currentPage = 'PageConnection';
        $NotificationSystem.reload();

        Promise.all([SettingsApi.getFilterConfig(get(api), 'view_connection')])
            .then(response => {
                $connections_filter_config = response[0];
            })
            .catch(error => {
                console.error('getFilterConfig', error);
            });
    });

    $: showMonit = $routes.selectMode === 'filtered' || $routes.selectedOrUnselected.length > 0;

    $: {
        routeCounterTooltip = {content: '', theme: ''};
        if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_connections !== null) {
            if ($routes.countTotal.count >= $app.settingsReadonly?.max_connections) {
                routeCounterWrapper = WarningColor;
                routeCounterTooltip.content = $_('connection_limit_exceeded', {values: {limit: $app.settingsReadonly?.max_connections}});
                routeCounterTooltip.theme = 'lastmile-warning-tooltip';
            } else if ($routes.countTotal.count >= 0.9 * $app.settingsReadonly?.max_connections) {
                routeCounterWrapper = NoticeColor;
                routeCounterTooltip.content = $_('connection_limit_approaching', {values: {current: $routes.countTotal.count, limit: $app.settingsReadonly?.max_connections}});
                routeCounterTooltip.theme = 'lastmile-notice-tooltip';
            } else {
                routeCounterWrapper = Opacity;
                routeCounterTooltip.content = $_('connection_limit_safe', {values: {current: $routes.countTotal.count, limit: $app.settingsReadonly?.max_connections}});
                routeCounterTooltip.theme = 'lastmile-tooltip';
            }
        } else {
            routeCounterWrapper = Opacity;
        }
        transactionCounterTooltip = {content: '', theme: ''};
        if (!$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_transactions_per_month !== null) {
            if ($routes.currentTransactionCount.count >= $app.settingsReadonly?.max_transactions_per_month) {
                transactionCounterWrapper = WarningColor;
                transactionCounterTooltip.content = $_('transaction_limit_exceeded', {values: {limit: $app.settingsReadonly?.max_transactions_per_month}});
                transactionCounterTooltip.theme = 'lastmile-warning-tooltip';
            } else if ($routes.currentTransactionCount.count >= 0.9 * $app.settingsReadonly?.max_transactions_per_month) {
                transactionCounterWrapper = NoticeColor;
                transactionCounterTooltip.content = $_('transaction_limit_approaching', {values: {limit: $app.settingsReadonly?.max_transactions_per_month}});
                transactionCounterTooltip.theme = 'lastmile-notice-tooltip';
            } else {
                transactionCounterWrapper = Opacity;
                transactionCounterTooltip.content = $_('transaction_limit_safe', {values: {current: $routes.currentTransactionCount.count, limit: $app.settingsReadonly?.max_transactions_per_month}});
                transactionCounterTooltip.theme = 'lastmile-tooltip';
            }
        } else {
            transactionCounterWrapper = Opacity;
        }
    }
</script>

<TemplateStandard>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderTrio>
            <div slot="main-header">
                <div
                    style="display: flex; flex-direction: row; column-gap: 6px; align-items: {($app.settingsReadonly?.allow_limit_exceeding || ($app.settingsReadonly?.max_connections === null && $app.settingsReadonly?.max_transactions_per_month === null) ? 'baseline' : 'center')}; "
                >
                    <div>{$_('Routes')}</div>
                    <div style="display: flex; flex-direction: column">
                    {#if !$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_connections !== null}
                        <div style="font-size: 12px; margin-top: 3px; display: flex; gap: 5px;"
                            use:tooltip={routeCounterTooltip.content ? { content: routeCounterTooltip.content, position: 'bottom', autoPosition: true, theme: routeCounterTooltip.theme, maxWidth: 350 } : null }
                            on:mouseenter={() => {
                                setTimeout(() => {
                                    window.dispatchEvent(new Event('resize'));
                                }, 0);
                            }}
                        >
                            <svelte:component this={routeCounterWrapper}>
                                <div style="display: flex; flex-direction: row; gap: 3px">
                                    <IconRoute scale={0.5}/>
                                    {$routes.countTotal.count} / {$app.settingsReadonly?.max_connections}
                                </div>
                            </svelte:component>
                            {#if routeCounterWrapper === WarningColor}
                                <span style="display: inline-block; width: 14px; background-color: #e28255; color: #ffffff; border-radius: 9px; text-align: center; font-weight: bold">!</span>
                            {/if}
                        </div>
                    {/if}
                    {#if !$app.settingsReadonly?.allow_limit_exceeding && $app.settingsReadonly?.max_transactions_per_month !== null}
                        <div style="font-size: 12px; margin-top: 3px; display: flex; gap: 5px;"
                            use:tooltip={transactionCounterTooltip.content ? { content: transactionCounterTooltip.content, position: 'bottom', autoPosition: true, theme: transactionCounterTooltip.theme, maxWidth: 350 } : null }
                            on:mouseenter={() => {
                                setTimeout(() => {
                                    window.dispatchEvent(new Event('resize'));
                                }, 0);
                            }}
                        >
                            <svelte:component this={transactionCounterWrapper}>
                                <div style="display: flex; flex-direction: row; gap: 3px">
                                    <IconTransaction scale={0.5}/>
                                    {$routes.currentTransactionCount.count} / {$app.settingsReadonly?.max_transactions_per_month}
                                </div>
                            </svelte:component>
                            {#if transactionCounterWrapper === WarningColor}
                                <span style="display: inline-block; width: 14px; background-color: #e28255; color: #ffffff; border-radius: 9px; text-align: center; font-weight: bold">!</span>
                            {/if}
                        </div>
                    {/if}
                    {#if $routes.countTotal.count && ($app.settingsReadonly?.allow_limit_exceeding || ($app.settingsReadonly?.max_connections === null && $app.settingsReadonly?.max_transactions_per_month === null))}
                        <div style="font-size: 12px;">
                            <Opacity>({$routes.countTotal.count})</Opacity>
                        </div>
                    {/if}
                    </div>
                </div>
            </div>
            <div
                slot="main-search"
                style="display: flex; align-items: center; justify-content: flex-start; column-gap: 8px;"
            >
                <SearchInput
                    placeholder={$_('City, street, name, connection')}
                    query={$filter.connections.quickSearch}
                    onChange={q => {
                        $filter.connections.quickSearch = q;
                    }}
                    onKeyup={q => {
                        $filter.connections.quickSearch = q;
                    }}
                    debounceTime={200}
                />
                <Opacity>
                    <IconHelp
                        scale={0.6}
                        hover={$_('Examples: one-way connection AAA-BBB, two-way AAA=BBB')}
                    />
                </Opacity>
            </div>
            <div slot="main-buttons" style="display:flex; align-items: center; column-gap: 25px;">
                <MenuContextJobs visibleOptions={['upload-file', 'manual-add-connection']} />
            </div>
        </TemplateHeaderTrio>
    </div>
    <div slot="content-header">
        {#if !$canWrite}
            <InlineInfoAboutAccountDisabilities center={false} text={$_(writeDisabledBanner)} />
        {/if}
    </div>
    <div slot="monit">
        {#if showMonit}
            <div style="position: relative;">
                <MonitActionForSelectedJob />
            </div>
        {/if}
    </div>
    <div slot="content" style="display: flex; flex-direction: column; overflow-y: auto;">
        <ConnectionList {showMonit} />
    </div>
    <div slot="footer"></div>
</TemplateStandard>

<style>
</style>
